import React, { useContext } from 'react';

import CardDialog from '~/components/CardDialog';
import { MarkdownRendererContext } from '~/components/Clive/CliveMarkdownDisplay/MarkdownRendererContext';

interface SourceTextDialogProps {
  title: string;
  text: string;
  onClose: () => void;
}

/** A cited source's full text, rendered as markdown so its own citations keep working. */
export const SourceTextDialog: React.FC<SourceTextDialogProps> = ({ title, text, onClose }) => {
  const MarkdownRenderer = useContext(MarkdownRendererContext);

  return (
    <CardDialog isDialog title={title} onClose={onClose} maxWidth="md" fullWidth>
      <MarkdownRenderer content={text} />
    </CardDialog>
  );
};
